/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react"; // React Stuff
// Common
import FadeIn from "../common/FadeIn";
import StatusBlock from "../common/StatusBlock";
//Packages
import axios from "axios";
import { Container, Row, Col, Button, Form } from "react-bootstrap";
import { isAuthenticated } from "./services/auth"; //import auth
import { Navigate } from "react-router-dom";
//Images and Icons
import { MdOutlineCancel, MdAddCircle } from "react-icons/md";

const AwardsTypesList = () => {
  const [awards, setAwards] = useState([]);
  // Error and Click Handling
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [submitClicked, setSubmitClicked] = useState(false);
  // View Mode
  const [viewMode, setViewMode] = useState("view");

  // Get the Tutor Details
  useEffect(async () => {
    const awardsRequest = await axios.get(`/api/admin/report_cards/awards`, {
      withCredentials: true,
    });
    return setAwards(awardsRequest.data);
  }, []);

  //Fetch new data as required
  const fetchNewData = async () => {
    const awardsRequest = await axios.get(`/api/admin/report_cards/awards`, {
      withCredentials: true,
    });
    return setAwards(awardsRequest.data);
  };

  // Dismiss Message
  const dismissMessages = () => {
    setSuccessMessage("");
    return setErrorMessage("");
  };

  return (
    <div className='AwardsList'>
      <FadeIn delay={250} duration={450}>
        {isAuthenticated() ? (
          <Container className='text-center'>
            <Row>
              <Col sm='12'>
                <h2>Your Awards</h2>
                <div>
                  <StatusBlock
                    errorMessage={errorMessage}
                    successMessage={successMessage}
                    dismissMessages={dismissMessages}
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col sm='12' className='text-center'>
                <ViewModeButtons setViewMode={setViewMode} viewMode={viewMode} />
              </Col>
            </Row>
            {viewMode === "view" && (
              <AwardBoxes
                awards={awards}
                fetchNewData={fetchNewData}
                setSubmitClicked={setSubmitClicked}
                submitClicked={submitClicked}
                setErrorMessage={setErrorMessage}
                setViewMode={setViewMode}
                setSuccessMessage={setSuccessMessage}
              />
            )}
            {viewMode === "add" && (
              <AwardAddForm
                fetchNewData={fetchNewData}
                setSubmitClicked={setSubmitClicked}
                submitClicked={submitClicked}
                setErrorMessage={setErrorMessage}
                setViewMode={setViewMode}
                setSuccessMessage={setSuccessMessage}
              />
            )}
          </Container>
        ) : (
          <Navigate to='/admin/' />
        )}
      </FadeIn>
    </div>
  );
};

const AwardBoxes = (props) => {
  const deleteAward = async (_id, e) => {
    e.preventDefault();
    props.setSubmitClicked(true);
    const deleteAwardRequest = await axios.delete(`/api/admin/manage/awards/${_id}`, {
      withCredentials: true,
    });
    if (deleteAwardRequest.status === 200) {
      props.setSubmitClicked(false);
      window.scrollTo(10, 0);
      props.setSuccessMessage("Successfully deleted award.");
      return props.fetchNewData();
    } else {
      props.setSubmitClicked(false);
      window.scrollTo(10, 0);
      return props.setErrorMessage("There was a problem with your request.");
    }
  };
  return (
    <Row>
      {props.awards
        .sort((a, b) => a.Type.localeCompare(b.Type))
        .map((award) => (
          <Col key={award._id} sm='12' lg='6'>
            <FadeIn delay={50} duration={450}>
              <div className='mx-1 mt-3 p-2 shadow text-center border'>
                <h3>{award.Type}</h3>
                {award.AwardURL !== "" && (
                  <a target='_blank' rel='noopener noreferrer' href={award.AwardURL}>
                    Link
                  </a>
                )}
                <hr />
                <span>{award.ShortDescription.substring(0, 25)}</span>
                <hr />
                <Button
                  variant='danger'
                  className='ms-1 mb-2'
                  onClick={(e) => deleteAward(award._id, e)}
                  disabled={props.submitClicked}
                >
                  Delete <MdOutlineCancel />
                </Button>
              </div>
            </FadeIn>
          </Col>
        ))}
    </Row>
  );
};

const AwardAddForm = (props) => {
  const [Type, setType] = useState("");
  const [ShortDescription, setShortDescription] = useState("");
  const [AwardURL, setAwardURL] = useState("");
  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = {
      Type,
      ShortDescription,
      AwardURL,
    };
    // Make the API call
    const requestNewAwardType = await axios.post("/api/admin/manage/awards", data, {
      withCredentials: true,
    });
    if (requestNewAwardType.status === 200) {
      props.setSubmitClicked(false);
      props.setSuccessMessage("Successfully new award type.");
      window.scrollTo(10, 0);
      props.setViewMode("view");
      return props.fetchNewData();
    } else {
      props.setSubmitClicked(false);
      window.scrollTo(10, 0);
      return props.setErrorMessage("There was a problem with your request.");
    }
  };

  return (
    <Row>
      <Col sm='12'>
        <FadeIn delay={50} duration={450}>
          <div className='mx-1 mt-3 p-2 shadow text-center border'>
            <Form className='post' onSubmit={handleSubmit}>
              <Row>
                <Col md='6' className='mt-2  pl-3 pr-3'>
                  <Form.Group controlId='AwardType'>
                    <Form.Label>Title/Type</Form.Label>
                    <Form.Control
                      type='text'
                      maxLength='50'
                      value={Type}
                      onChange={(e) => setType(e.target.value)}
                      className='border'
                      required
                    />
                    <Form.Text className='text-muted'>
                      The title or type you want to display.
                    </Form.Text>
                  </Form.Group>
                </Col>
                <Col md='6' className='mt-2  pl-3 pr-3'>
                  <Form.Group controlId='AwardURL'>
                    <Form.Label>Award URL</Form.Label>
                    <Form.Control
                      type='url'
                      pattern='https://.*'
                      maxLength='256'
                      value={AwardURL}
                      onChange={(e) => setAwardURL(e.target.value)}
                      placeholder='https://...'
                      className='border'
                    />
                    <Form.Text className='text-muted'>
                      The URL link for the Award to be purchased, starting with https://.
                    </Form.Text>
                  </Form.Group>
                </Col>
              </Row>
              <Form.Group controlId='ClassTypeForm'>
                <Form.Label>Short Description</Form.Label>
                <Form.Control
                  as='textarea'
                  type='text'
                  maxlength='256'
                  value={ShortDescription}
                  onChange={(e) => setShortDescription(e.target.value)}
                  className='border'
                  required
                />
                <Form.Text className='text-muted'>
                  Up to 256 character description of the type of award this is.
                </Form.Text>
              </Form.Group>

              <Col className='mt-2 mb-2'>
                <Button variant='success' type='submit'>
                  Create Award Type
                </Button>
              </Col>
            </Form>
          </div>
        </FadeIn>
      </Col>
    </Row>
  );
};

const ViewModeButtons = (props) => {
  if (props.viewMode === "add" || props.viewMode === "edit") {
    return (
      <FadeIn delay={50} duration={450}>
        <Button
          variant='secondary'
          value='view'
          className='m-1'
          onClick={(e) => props.setViewMode(e.target.value)}
        >
          <MdOutlineCancel />
          Return
        </Button>
      </FadeIn>
    );
  } else {
    return (
      <FadeIn delay={50} duration={450}>
        <Button
          variant='primary'
          value='add'
          className='m-1'
          onClick={(e) => props.setViewMode(e.target.value)}
        >
          <MdAddCircle />
          Add an Award
        </Button>
      </FadeIn>
    );
  }
};

export default AwardsTypesList;
